import { generateTestId } from "@client-shared";

export const setConfigureProductModalTestId = (identifier: string): string =>
  generateTestId("ConfigureProductModal", identifier);
